export default "__VITE_ASSET__kBJ6cOgQ__"